"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCountries;

var _metadata = _interopRequireDefault(require("./metadata.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getCountries(metadata) {
  return new _metadata["default"](metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/build/getCountries.js
// module id = 1343
// module chunks = 0